import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { HiLoManager } from "../../managers/HiLoManager";
import { AudioManager } from "../../managers/AudioManager";

export class HiLoCardsContainer extends Phaser.GameObjects.Container {

    public static currentInstance: HiLoCardsContainer;
    public static DECK_PX = 270;

    private cards: Phaser.GameObjects.Image [];
    private deck: Phaser.GameObjects.Image [];

    constructor(scene: Phaser.Scene) {

        super(scene);

        HiLoCardsContainer.currentInstance = this;

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = 300;

        this.scaleX = GameVars.scaleX;

        this.cards = [];
        this.deck = [];

        for (let i = 0; i < 14; i ++) {
            const card = new Phaser.GameObjects.Image(this.scene, HiLoCardsContainer.DECK_PX - i * .75, -i * .75, "texture_atlas_2", "card-back.png");
            card.setScale(1.15);
            this.add(card);

            this.deck.push(card);
        }

        this.scene.time.addEvent({delay: 500, callback: () => {
            this.addCard(HiLoManager.getCard());
        }, callbackScope: this});
        
    }

    public addCard(value: string): void {

        const cardFromDeck = this.deck.pop();

        const frameName = GameVars.cardFrameName(value) + ".png";
        
        const card = new Phaser.GameObjects.Image(this.scene, cardFromDeck.x, cardFromDeck.y, "texture_atlas_2", frameName);
        card.setScale(1.1);
        card.alpha = 0;
        card.name = value;
        this.add(card);

        cardFromDeck.destroy();

        this.cards.push(card);

        this.scene.tweens.add({
            targets: card,
            alpha: 1,
            ease: Phaser.Math.Easing.Quadratic.Out,
            duration: 250,
            onComplete: function(): void {

                AudioManager.playSound("card_reveal_" + (Math.floor(Math.random() * 3) + 1));
                
                this.scene.tweens.add({
                    targets: card,
                    x: 10 - 20 * Math.random(),
                    y: 10 - 20 * Math.random(),
                    angle: 4 - 8 * Math.random(),
                    ease: Phaser.Math.Easing.Quadratic.In,
                    duration: 350
                });
            },
            onCompleteScope: this
        });
    }

    public onGameOver(): void {

        this.hideOnComplete();
    }

    public onGameContainer(): void {

        this.hideOnComplete();
    }

    public hideOnComplete(): void {

        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250,
            delay: 500
        });
    }

    public onReplay(): void {

        this.alpha = 1;

        for (let i = 0; i < this.cards.length; i ++) {

            const card = this.cards[i];
            card.destroy();
        }

        this.cards = [];
        this.deck = [];

        for (let i = 0; i < 14; i ++) {
            const card = new Phaser.GameObjects.Image(this.scene, HiLoCardsContainer.DECK_PX - i * .75, -i * .75, "texture_atlas_2", "card-back.png");
            card.setScale(1.15);
            this.add(card);

            this.deck.push(card);
        }

        this.addCard(HiLoManager.getCard());
    }
}
